import { Box, Typography } from '@mui/material';
import { useRouter } from 'next/router';

import CuminButton from '@components/Button';
import theme from 'src/style-system/theme';

import { useStyles } from './useStyles';

interface IContactUsComponent {
  slice: any;
}

const ContactUsComponent = ({ slice }: IContactUsComponent) => {
  const {
    title,
    description,
    ctalink,
    ctatext,
    desktopbackgroungimg,
    mobilebackgroundimg,
  } = slice?.primary || {};

  const { url: mbUrl } = mobilebackgroundimg || {};
  const { url: dtUrl } = desktopbackgroungimg || {};

  const router = useRouter();

  const classes = useStyles();

  return (
    <Box
      className={classes.mainContainer}
      sx={{
        backgroundImage: `url(${dtUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        [theme.breakpoints.down('md')]: {
          backgroundImage: `url(${mbUrl})`,
        },
      }}
    >
      <Box className={classes.container}>
        <Typography
          variant="h2"
          color="garamMasala.main"
          sx={{
            textAlign: 'center',
            [theme.breakpoints.up('sm')]: {
              textAlign: 'left',
            },
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          color="garamMasala.main"
          m="20px 0 30px"
          sx={{
            textAlign: 'center',
            [theme.breakpoints.up('sm')]: {
              textAlign: 'left',
            },
          }}
        >
          {description}
        </Typography>
        <CuminButton
          variant="contained"
          color="cinnamon"
          borderRadius="24"
          textColor="whitePepper.main"
          width="200px"
          height="50"
        >
          <a href={ctalink?.url}>{ctatext}</a>
        </CuminButton>
      </Box>
    </Box>
  );
};

export default ContactUsComponent;
